import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-4">Terms and Conditions</h1>
      <p className="mb-4">Last updated: July 30, 2025</p>
      <p className="mb-4">
        Please read these terms and conditions carefully before using Our
        Service.
      </p>

      <h2 className="text-2xl font-bold mt-6 mb-2">Acknowledgment</h2>
      <p className="mb-4">
        These are the Terms and Conditions governing the use of this Service
        and the agreement that operates between You and the Company. These
        Terms and Conditions set out the rights and obligations of all users
        regarding the use of the Service.
      </p>
      <p className="mb-4">
        By accessing or using the Service You agree to be bound by these Terms
        and Conditions. If You disagree with any part of these Terms and
        Conditions then You may not access the Service.
      </p>

      <h2 className="text-2xl font-bold mt-6 mb-2">Links to Other Websites</h2>
      <p className="mb-4">
        Our Service may contain links to third-party web sites or services
        that are not owned or controlled by the Company.
      </p>
      <p className="mb-4">
        The Company has no control over, and assumes no responsibility for,
        the content, privacy policies, or practices of any third party web
        sites or services. You further acknowledge and agree that the Company
        shall not be responsible or liable, directly or indirectly, for any
        damage or loss caused or alleged to be caused by or in connection
        with the use of or reliance on any such content, goods or services
        available on or through any such web sites or services.
      </p>

      <h2 className="text-2xl font-bold mt-6 mb-2">Termination</h2>
      <p className="mb-4">
        We may terminate or suspend Your access immediately, without prior
        notice or liability, for any reason whatsoever, including without
        limitation if You breach these Terms and Conditions.
      </p>

      <h2 className="text-2xl font-bold mt-6 mb-2">Limitation of Liability</h2>
      <p className="mb-4">
        To the maximum extent permitted by applicable law, in no event shall
        the Company or its suppliers be liable for any special, incidental,
        indirect, or consequential damages whatsoever.
      </p>

      <h2 className="text-2xl font-bold mt-6 mb-2">
        "AS IS" and "AS AVAILABLE" Disclaimer
      </h2>
      <p className="mb-4">
        The Service is provided to You "AS IS" and "AS AVAILABLE" and with all
        faults and defects without warranty of any kind.
      </p>

      <h2 className="text-2xl font-bold mt-6 mb-2">Governing Law</h2>
      <p className="mb-4">
        The laws of the Country, excluding its conflicts of law rules, shall
        govern this Terms and Your use of the Service.
      </p>

      <h2 className="text-2xl font-bold mt-6 mb-2">Disputes Resolution</h2>
      <p className="mb-4">
        If You have any concern or dispute about the Service, You agree to
        first try to resolve the dispute informally by contacting the Company.
      </p>

      <h2 className="text-2xl font-bold mt-6 mb-2">
        Changes to These Terms and Conditions
      </h2>
      <p className="mb-4">
        We reserve the right, at Our sole discretion, to modify or replace
        these Terms at any time.
      </p>

      <h2 className="text-2xl font-bold mt-6 mb-2">Contact Us</h2>
      <p className="mb-4">
        If you have any questions about these Terms and Conditions, You can
        contact us:
      </p>
      <ul className="list-disc list-inside mb-4">
        <li>By email: support@codeblaze.net</li>
      </ul>
    </div>
  );
};

export default TermsAndConditions;
